







































































import { Component, Vue } from 'vue-property-decorator';
import WhatsappIcon from 'vue-material-design-icons/Whatsapp.vue';
import RdStation from '@/plugins/api/RdStation';

@Component({
  components: { WhatsappIcon },
})
export default class DetalhesSidebar extends Vue {
  get showSidebar() {
    return this.$store.getters.show_sidebar;
  }

  get loadingCotacao() {
    return this.$store.state.loading_cotacao;
  }

  get valorMensal() {
    return this.$store.getters.valor_mensalidade;
  }

  get valorCortado() {
    return this.$store.getters.valor_cortado;
  }

  get valorAnual() {
    return this.$store.getters.valor_anual;
  }

  get valorAdesao() {
    return this.$store.state.cotacao.valor_adesao;
  }
  // noinspection JSMethodCanBeStatic
  public get year() {
    return new Date().getFullYear();
  }

  public openWhatsApp() {
    let url = 'http://wa.me/554491056559?text=Ol%C3%A1,%20acabei%20de%20fazer%20minha%20simula%C3%A7%C3%A3o%20no%20site%20e%20quero%20mais%20informa%C3%A7%C3%B5es';

    if (this.$store.state.vendedor && this.$store.state.vendedor.link) {
      url = this.$store.state.vendedor.link;
    }

    window.open(url, '_blank');
    RdStation.conversion({
      'email': this.$store.getters.get_email,
      'identificador': 'Clicou em Whatsapp',
      'Clicou em Whatsapp': 'Sim',
      'id_proposta': this.$store.state.cotacao.id,
      'id_vendedor': this.$store.state.cotacao.vendedor ?? 16482,
    }).then();
  }
}
